export enum PhotoType {
    Hospital = 0,
    Patient = 1,
    Doctor = 2,
    Lab = 3,
    Radiology = 4,
    MedicalStore = 5,
    HospitalIcon = 6,
    LifemaanBot = 7
}
